import { AnimationOnScroll } from "react-animation-on-scroll";

export default function ContactItem({ icon, text, link }) {
  return (
    <AnimationOnScroll animateIn="animate__fadeInUp">
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        className="flex items-center bg-color2 w-full sm:w-[35rem] h-16 sm:h-24 border my-4 contact-button"
      >
        <div className="w-16 sm:w-28 flex justify-center transition-colors duration-1000">
          {icon}
        </div>
        <h5 className=" sm:text-2xl transition-colors duration-1000 ">
          {text}
        </h5>
      </a>
    </AnimationOnScroll>
  );
}
